import React from "react";
import {
  ChartComponentProps,
  ChartConfig,
  createChartConfig,
  StageDataPoint,
} from "src/components/Referral-partner/Analytics/analyticsTypes";
import ConversionFunnel from "src/components/Referral-partner/Analytics/charts/ConversionFunnel";
import { WarningWrapper } from "src/components/Referral-partner/Analytics/styles/shared.styles";
import api from "src/store/features/api";

const useGetReferralConversionsConfig = (): {
  referralConversions: ChartConfig<StageDataPoint>;
} => {
  // fetch data and states
  const {
    data: rawConversions,
    isLoading: convIsLoading,
    isFetching: convIsFetching,
    isError: convIsError,
    error: convError,
  } = api.useGetReferralConversionMetricsQuery();

  // format data
  const conversionsData = React.useMemo((): StageDataPoint[] => {
    if (!rawConversions) return [];
    return [
      { stage: "Sign Ups", customers: rawConversions.signedUp },
      { stage: "Verified", customers: rawConversions.verified },
      { stage: "Active Customers", customers: rawConversions.activeCustomers },
    ];
  }, [rawConversions]);

  // create chart config
  const referralConversionsConfig = React.useMemo(
    (): { referralConversions: ChartConfig<StageDataPoint> } => ({
      referralConversions: createChartConfig<StageDataPoint>({
        title: "Signup Conversion",
        type: "bar",
        menuMode: "normal",
        defaultDate: "all time",
        dateOptions: [
          {
            label: "all time",
            value: "ALL",
          },
        ],
        tooltip: "How Many Referrals Progress from Sign-up to Active Trading",
        isLoading: convIsLoading || convIsFetching,
        data: conversionsData,
        component: ({ data }: ChartComponentProps<StageDataPoint>): JSX.Element => {
          if (convIsError) {
            return <WarningWrapper>{convError?.message}</WarningWrapper>;
          } else {
            return <ConversionFunnel data={data} />;
          }
        },
      }),
    }),
    [conversionsData, convIsLoading, convIsFetching, convIsError, convError],
  );

  return referralConversionsConfig;
};

export default useGetReferralConversionsConfig;
